'use strict';
import angular from 'angular';
import customMacrosHtmlUrl from './views/customMacros.html';

let app = angular.module('app.customMacrosComponent', []);

const MacroMappings = [
    {
        macro: 'FIRSTNAME',
        audienceMapping: 'first_name',
        showInSeedList: true,
    },
    {
        macro: 'LASTNAME',
        audienceMapping: 'last_name',
        showInSeedList: true,
    },
    {
        macro: 'ADDRESS',
        audienceMapping: 'address1',
        showInSeedList: true,
    },
    {
        macro: 'ADDRESS2',
        audienceMapping: 'address2',
        showInSeedList: true,
    },
    {
        macro: 'CITY',
        audienceMapping: null,
        showInSeedList: true,
    },
    {
        macro: 'STATE',
        audienceMapping: null,
        showInSeedList: true,
    },
    {
        macro: 'ZIP',
        audienceMapping: 'zip5',
        showInSeedList: true,
    },
    {
        macro: 'EMAIL',
        audienceMapping: 'email',
        showInSeedList: false,  // It's actually shown, but always at the top, so set it to false to avoid processing it twice
    },
    {
        macro: 'BRIDGE_ID',
        audienceMapping: 'person_id', // Yes, person_id, even if it's not bridge_id.
        showInSeedList: true,
    },
    {
        macro: 'SHA1EMAIL',
        audienceMapping: null, // May be set to something when Bridge decides what it is
        showInSeedList: true,
    },
    {
        macro: 'BROWSERVIEWLINK',
        audienceMapping: null,
        showInSeedList: false,
    },
];

app.component('customMacros', {
    bindings: {
        audienceMacroMappings: '<',
        audienceMatchMappings: '<',
        enableMapping: '<',
        emailMacros: '<',
        seedListMode: '<',
        htmlValidationStatus: '<',
    },
    templateUrl: customMacrosHtmlUrl,
    controller: function () {
        let self = this;
        self.macroList = [];
        self.customList = [];
        if (!self.audienceMacroMappings) {
            self.audienceMacroMappings = [];
        }
        if (!self.audienceMatchMappings) {
            self.audienceMatchMappings = [];
        }
        if (!self.emailMacros || !self.enableMapping) {
            self.emailMacros = [];
        } else {
            // This field is sent to us from the backend as a string.
            self.emailMacros = JSON.parse(self.emailMacros);
        }
        let emailMacrosLeft = _.clone(self.emailMacros);

        if (self.seedListMode) {
            // Seed list mode (the widget is on task forms). EMAIL is always first, then any standard macros, then
            // any configured custom macros (CUSTOM[1-25] and CUSTOM_URL), then any others.
            let currentChar = 'A';

            // 1) Email macro
            const m = {};
            m.columnOrder = currentChar;
            m.key = 'EMAIL';
            // In the match mappings, email is lowercase.
            m.value = self.audienceMatchMappings.hasOwnProperty('email') ? self.audienceMatchMappings['email'] : '-';
            self.macroList.push(m);
            // Remove the processed macros from the list as we go (with a case-insensitive match).
            const index = _.findIndex(emailMacrosLeft,
                (element) => element.toUpperCase() === 'EMAIL');
            if (index >= 0) {
                emailMacrosLeft.splice(index, 1);
            }

            // 2) Standard macros
            MacroMappings.forEach((mapping) => {
                const index = _.findIndex(emailMacrosLeft,
                    (element) => element.toUpperCase() === mapping.macro.toUpperCase());
                if (index >= 0) {
                    emailMacrosLeft.splice(index, 1);
                    if (mapping.showInSeedList) { // Skip a few like EMAIL (it's always at the top) and BROWSERVIEWLINK.
                        const m = {};
                        currentChar = nextChar(currentChar);
                        m.columnOrder = currentChar;
                        m.key = mapping.macro;
                        if (mapping.audienceMapping !== null && self.audienceMatchMappings.hasOwnProperty(mapping.audienceMapping)) {
                            m.value = self.audienceMatchMappings[mapping.audienceMapping];
                        } else {
                            m.value = '-';
                        }
                        self.macroList.push(m);
                    }
                }
            });

            // 3) Custom macros
            let counter = 0;
            for (let customIdx = 1; customIdx <= 25; customIdx++) {
                const customMacroName = 'CUSTOM' + customIdx;
                const index = _.findIndex(emailMacrosLeft,
                    (element) => element.toUpperCase() === customMacroName);
                if (index >= 0) {
                    emailMacrosLeft.splice(index, 1);
                    const m = {};
                    currentChar = nextChar(currentChar);
                    m.columnOrder = currentChar;
                    m.key = customMacroName;
                    m.value = self.audienceMacroMappings.hasOwnProperty(customMacroName) ? self.audienceMacroMappings[customMacroName] : '-';
                    m.first = (counter++ === 0);
                    self.customList.push(m);
                }
            }

            // 4) CUSTOM_URL
            const customUrlIndex = _.findIndex(emailMacrosLeft,
                (element) => element.toUpperCase() === 'CUSTOM_URL');
            if (customUrlIndex >= 0) {
                emailMacrosLeft.splice(customUrlIndex, 1);
                const m = {};
                currentChar = nextChar(currentChar);
                m.columnOrder = currentChar;
                m.key = 'CUSTOM_URL';
                m.value = self.audienceMacroMappings.hasOwnProperty('CUSTOM_URL') ? self.audienceMacroMappings['CUSTOM_URL'] : '-';
                m.first = (counter++ === 0); // counter was not reset to 0 after numbered CUSTOM macros, we're in the same section.
                self.customList.push(m);
            }

            // 5) Any remaining macros
            counter = 0; // Start a new section with a bold separator line
            emailMacrosLeft.forEach((remainingMacro) => {
                const m = {};
                currentChar = nextChar(currentChar);
                m.columnOrder = currentChar;
                m.key = remainingMacro;
                m.value = '-';
                m.first = (counter++ === 0);
                self.customList.push(m);
            });

        } else {
            // This is the other widget mode, for order/line/flight forms (see TO-6884 for the original requirements).
            MacroMappings.forEach((mapping) => {
                const m = {};
                m.key = mapping.macro;
                if (mapping.audienceMapping !== null && self.audienceMatchMappings.hasOwnProperty(mapping.audienceMapping)) {
                    m.value = self.audienceMatchMappings[mapping.audienceMapping];
                } else {
                    m.value = '-';
                }

                if (self.enableMapping) {
                    if (self?.htmlValidationStatus?.toLowerCase() === 'success') {
                        const index = _.findIndex(emailMacrosLeft,
                            (element) => element.toUpperCase() === mapping.macro.toUpperCase());
                        if (index >= 0) {
                            const mappingValue = emailMacrosLeft[index];
                            emailMacrosLeft.splice(index, 1);
                            m.html = mappingValue;
                            m.color = 'green';
                        } else {
                            m.html = 'Not found in HTML';
                            m.color = 'black';
                        }
                    } else {
                        // Validation results have not been received yet, so don't show anything except a dash.  Saying
                        // "Not found in HTML" would be wrong as we just don't know yet.
                        m.html = '-';
                        m.color = 'black';
                    }
                }
                self.macroList.push(m);
            });

            const audienceMappingKeys = Object.keys(self.audienceMacroMappings);
            let counter = 0;
            audienceMappingKeys.forEach((key) => {
                const m = [];
                const value = self.audienceMacroMappings[key];
                m.key = key;
                m.value = value;
                m.first = (counter++ === 0);
                if (self.enableMapping) {
                    if (self?.htmlValidationStatus?.toLowerCase() === 'success') {
                        const index = _.findIndex(emailMacrosLeft,
                            (element) => element.toUpperCase() === key.toUpperCase());
                        if (index >= 0) {
                            const mappingValue = emailMacrosLeft[index];
                            emailMacrosLeft.splice(index, 1);
                            m.html = mappingValue;
                            m.color = 'green';
                        } else {
                            m.html = 'Not found in HTML';
                            m.color = 'black';
                        }
                    } else {
                        // Validation results have not been received yet, so don't show anything.  Saying "Not found in HTML"
                        // would be wrong as we just don't know  yet.
                        m.html = '';
                        m.color = 'black';
                    }
                }
                self.customList.push(m);
            });

            if (self.enableMapping) {
                counter = 0;
                emailMacrosLeft.forEach((remainingMacro) => {
                    const m = {};
                    m.key = '';
                    m.value = '';
                    m.first = (counter++ === 0);
                    m.html = remainingMacro;
                    m.color = 'red';
                    self.customList.push(m);
                });
            }
        }

        // So we can generate columns like A, B, C, ..., Z, AA, AB, ..., ZZ, ...   (this was ripped off the web with trival modifs)
        function nextChar(c)
        {
            let u = c.toUpperCase();
            if (same(u,'Z')) {
                let txt = '';
                let i = u.length;
                while (i--) {
                    txt += 'A';
                }
                return (txt+'A');
            } else {
                let p = "";
                let q = "";
                if (u.length > 1) {
                    p = u.substring(0, u.length - 1);
                    q = String.fromCharCode(p.slice(-1).charCodeAt(0));
                }
                let l = u.slice(-1).charCodeAt(0);
                let z = nextLetter(l);
                return (z === 'A') ? (p.slice(0,-1) + nextLetter(q.slice(-1).charCodeAt(0)) + z) : (p + z);
            }
        }

        function nextLetter(l)
        {
            return (l < 90) ? String.fromCharCode(l + 1) : 'A';
        }

        function same(str,char)
        {
            let i = str.length;
            while (i--) {
                if (str[i] !== char) {
                    return false;
                }
            }
            return true;
        }
    }
});
